import React from "react";
import { Button, Card, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { ExportButton } from "@components/Common/Button";
import { DevForm } from "@components/Forms/Fields";
import { buildFormData } from "@components/Forms/Handlers";
import { RenderForm } from "@components/Forms/Render";
import { Awesome } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { downloadBase64File, scroll_to_top, url_reverse } from "@components/Utils";

export default function EventGenerateSerialsScreen() {
    const { t } = useTranslation();
    const { slug } = useParams();
    const apiUrl = url_reverse("api:event:selection:item:generate_serials", { event_slug: slug });
    const { apiData, setApiData } = useAppApi(apiUrl);
    const { api_post_formdata } = useRequest();

    const submitForm = (ev) => {
        ev.preventDefault();
        const formData = buildFormData({ ev, apiData, submitPrefixes: ["main"] });

        api_post_formdata(ev, apiUrl, formData, {
            then: (response) => {
                if (response.status === "ok") {
                    const { file_content, filename } = response;
                    downloadBase64File(file_content, filename);
                } else {
                    for (const prefix of ["main"]) {
                        const form = apiData.forms_data[prefix];
                        for (const [name, field] of Object.entries(form.fields)) {
                            const cur_val = form.data[name];
                            if (field.widget.input_type === "file" && cur_val) {
                                response.forms_data[form.prefix].data[name] = cur_val;
                            }
                        }
                    }
                    setApiData(response);
                    scroll_to_top();
                }
            },
        });
    };

    if (!apiData) return;

    const header = (
        <>
            <Link to={url_reverse("admin:event:items", { slug })}>{t("Управление ивентом")}</Link>
            <span> – </span>
            {t("Настройки ивента")}
        </>
    );

    const headerTools = (
        <>
            <Button
                className="mr-1"
                size="sm"
                variant="dark"
                as={Link}
                to={url_reverse("admin:event:send_serials", { slug })}
            >
                <Awesome type="envelope" tooltip={t("Рассылка ключей")} />
            </Button>
            <ExportButton size="sm" buildReport="games" buttonText={t("Скачать шаблон")} />
        </>
    );

    return (
        <DefaultLayout>
            <Card>
                <Card.Header>
                    {header}
                    <div className="dmg-card-header-tools">{headerTools}</div>
                </Card.Header>
                <Card.Body>
                    <Form onSubmit={submitForm}>
                        <RenderForm apiData={apiData} setApiData={setApiData} bareForm={true} />
                        <DevForm.Button variant="primary" type="submit" name="save">
                            {t("Сохранить")}
                        </DevForm.Button>
                    </Form>
                </Card.Body>
            </Card>
        </DefaultLayout>
    );
}
